import { gql } from "@apollo/client";

export const listKeywordGroups = gql`
  query ListKeywordGroups($filters: KeywordGroupFilter) {
    listKeywordGroups(filters: $filters) {
      id
      type
      slug
      imageUrl
      keywords
      name
      deleted
      metadata
      category
    }
  }
`;
